<nz-layout class="app-layout">
  <nz-sider
    class="menu-sidebar"
    nzCollapsible
    nzWidth="256px"
    nzBreakpoint="md"
    [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null"
    (change)="layoutChange($event)"
  >
    <div class="sidebar-logo">
      <a (click)="navigation('/admin/dashboard')">
        <img
          src="../../../assets/img/logo.png"
          alt="logo"
          class="object-contain"
        />
        <h1 class="text-white">SLJI Member Portal</h1>
      </a>
    </div>
    <ul
      nz-menu
      nzTheme="light"
      nzMode="inline"
      [nzInlineCollapsed]="isCollapsed"
    >

      <li [routerLink]="['/', 'admin', 'dashboard']" nz-menu-item nzMatchRouter>
        <span nz-icon nzType="dashboard"></span>
        <span >Dashboard</span>
      </li>

      <li [routerLink]="['/', 'admin', 'users']" nz-menu-item nzMatchRouter>
        <span nz-icon nzType="user"></span>
        <span >Members</span>
      </li>

      <li nz-submenu  nzTitle="Learning Resources" nzIcon="group">
        <ul>
          <li [routerLink]="['/', 'admin', 'resources-article']" nz-menu-item nzMatchRouter>
            <span >Articles</span>
          </li>
          <li [routerLink]="['/', 'admin', 'resources']" nz-menu-item nzMatchRouter>
            <span >Books</span>
          </li>
          <li [routerLink]="['/', 'admin', 'resources-video']" nz-menu-item nzMatchRouter >
            <span >Videos</span>
          </li>
        </ul>
      </li>

      <li [routerLink]="['/', 'admin', 'events']" nz-menu-item nzMatchRouter>
        <span nz-icon nzType="calendar"></span>
        <span >Events</span>
      </li>

      <li nz-submenu nzTitle="Legal Resources" nzIcon="file-text">
        <ul>
          <li [routerLink]="['/', 'admin', 'acts']" nz-menu-item nzMatchRouter>
            <span>Acts</span>
          </li>
          <li [routerLink]="['/', 'admin', 'judgments-orders']" nz-menu-item nzMatchRouter>
            <span>Judgments and Orders</span>
          </li>
          <li [routerLink]="['/', 'admin', 'search-judgments']" nz-menu-item nzMatchRouter>
            <span>Search Judgments</span>
          </li>
        </ul>
      </li>

      <li [routerLink]="['/', 'admin', 'news']" nz-menu-item nzMatchRouter>
        <span nz-icon nzType="reconciliation"></span>
        <span >News</span>
      </li>

      <li [routerLink]="['/', 'admin', 'media']" nz-menu-item nzMatchRouter>
        <span nz-icon nzType="picture"></span>
        <span >Media</span>
      </li>

      <li [routerLink]="['/', 'admin', 'downloads']" nz-menu-item nzMatchRouter>
        <span nz-icon nzType="download"></span>
        <span >Download</span>
      </li>

      <li nz-menu-item (click)="openSLJIDatabase()">
        <span nz-icon nzType="database"></span>
        <span>SLJI Database</span>
      </li>


    </ul>
  </nz-sider>
  <nz-layout>
    <nz-header>
      <div class="app-header bg-white">
        <div class="header-content">
      <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
        <i-lucide
          class="trigger"
          nz-icon
          nzType="{{
            isCollapsed ? 'menu-unfold' : 'menu-fold'
          }}"
        ></i-lucide>
      </span>


          <div class="user-card" *ngIf="isAuthenticated">
            <ng-container>
              <button  nz-button nz-dropdown nzTrigger="click" class="user-card-button mt-3" [nzDropdownMenu]="menu" nzPlacement="bottomRight">
                <div class="flex flex-row gap-2 items-center justify-between" >
                  <nz-avatar [nzSrc]="user.url" nzIcon="user" nzSize="small"></nz-avatar>
                  <div  style="text-align: left">
                    <p class="font-semibold text-sm tracking-tight leading-3 my-0">{{user.name}}</p>
                    <p class="font-normal text-[10px] my-0">Member</p>
                  </div>
                </div>
              </button>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item  class="font-normal" (click)="routeToProfile()">My Account</li>
                  <li nz-menu-item class="font-normal" style="color: red" (click)="logout()" >Log Out</li>
                </ul>
              </nz-dropdown-menu>
            </ng-container>
          </div>

          



        </div>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content 2xl:p-6 lg:p-4 p-4">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
